module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNyIgaGVpZ2h0PSIxNyIgdmlld0JveD0iMCAwIDE3IDE3Ij4KICAgIDxwYXRoIGZpbGw9IiM4ODhCOTQiIGZpbGwtcnVsZT0ibm9uemVybyIKICAgICAgICAgIGQ9Ik0xMi41OTkgMTEuMTg0QTYuOTU0IDYuOTU0IDAgMCAwIDE0IDdjMC0zLjg2LTMuMTQxLTctNy03UzAgMy4xNCAwIDdzMy4xNDEgNyA3IDdhNi45NTggNi45NTggMCAwIDAgNC4xODUtMS40MDJsMy41NiAzLjIzN2EuOTk3Ljk5NyAwIDAgMCAxLjQxMyAwIC45OTkuOTk5IDAgMCAwIDAtMS40MTRMMTIuNiAxMS4xODR6TTIgN2MwLTIuNzU3IDIuMjQzLTUgNS01czUgMi4yNDMgNSA1LTIuMjQzIDUtNSA1LTUtMi4yNDMtNS01eiIvPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/search.svg
// module id = mLep
// module chunks = 0 162 195